import { render, staticRenderFns } from "./ele14.vue?vue&type=template&id=035baa8f&scoped=true"
import script from "./ele14.vue?vue&type=script&lang=js"
export * from "./ele14.vue?vue&type=script&lang=js"
import style0 from "./ele14.vue?vue&type=style&index=0&id=035baa8f&prod&lang=scss"
import style1 from "./ele14.vue?vue&type=style&index=1&id=035baa8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035baa8f",
  null
  
)

export default component.exports